import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {recordAuditRoutes} from '@dms/routes';

import {RecordAuditCreate} from './pages/RecordAuditCreate/RecordAuditCreate';
import {RecordAuditDetail} from './pages/RecordAuditDetail/RecordAuditDetail';
import {RecordAuditList} from './pages/RecordAuditList/RecordAuditList';

export const RecordAuditsModule: Module = {
  id: moduleKeys.recordAudit,
  requiredFeatureFlag: featureFlags.CORE_CHECKLIST_AUDITS,
  layoutProps: {
    title: 'page.checklistAudits.title',
    icon: 'sidebar/inspection',
  },
  routerProps: {
    path: recordAuditRoutes.overview,
  },
  content: [
    {
      id: 'recordAudit.overview',
      routerProps: {
        path: recordAuditRoutes.overview,
        element: <RecordAuditList />,
      },
      layoutProps: {
        title: 'page.checklistAudits.title',
        icon: 'sidebar/inspection',
      },
    },
    {
      id: 'recordAudit.create',
      routerProps: {
        path: recordAuditRoutes.create,
        element: <RecordAuditCreate />,
      },
    },
    {
      id: 'recordAudit.detail',
      routerProps: {
        path: recordAuditRoutes.detail,
        element: <RecordAuditDetail />,
      },
    },
  ],
};
